import axios from 'axios'

const service = axios.create({
  baseURL: process.env.VUE_APP_LOG_API,
  timeout: 50000
})

service.interceptors.request.use(
  request => {
    request.headers['x-api-key'] = process.env.VUE_APP_LOG_API_X_API_KEY
    return request
  },
  error => {
    return Promise.reject(error)
  }
)

export default service
